import React, { useContext } from 'react'
import { css } from '@emotion/native'
import { Image, ImageBackground } from 'react-native'
import { ThemeContext, H3, Button, View } from './../pagui'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { LG_SIZE, XL_SIZE } from '~/pagui/components/View'
import { Link } from 'gatsby-plugin-intl'
import LinkButton from './../components/LinkButton'

type Props = {
  title: string
  img: string
  imgBackground?: string
  linkTo: string
  link?: string
  alt? : string
} & InjectedIntlProps

const cardStyle = css({
  backgroundColor: '#141414',
  width: 550,
  height: 600,
  borderRadius: 10,
})

const cardStyleLG = css({
  backgroundColor: '#141414',
  width: 170,
  height: 300,
  borderRadius: 10,
})

const imgStyle = css({
  width: 180,
  height: 200,
  resizeMode: 'contain',
})

const imgStyleLG = css({
  width: 90,
  height: 90,
  resizeMode: 'contain',
})

const titleStyle = css({
  color: 'white',
  textAlign: 'center',
})

const fontSizeXL = css({
  fontSize: 25,
  lineHeight: 35,
})

const fontSizeLG = css({
  fontSize: 15,
  lineHeight: 15,
})

const imgBackgroundXL = css({
  // flex: 1,
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
})

const DarkCard: React.FC<Props> = ({
  title,
  img,
  imgBackground,
  link,
  linkTo,
  alt,
  intl: { formatMessage },
}) => {
  const [theme] = useContext(ThemeContext)

  return (
    <>
      <View
        minShowSize={LG_SIZE}
        style={[
          cardStyle,
          theme.styles.m1,
          theme.styles.mb5,
          theme.styles.flexColCenter,
        ]}
      >
        <ImageBackground
          style={[imgBackgroundXL]}
          source={{ uri: imgBackground }}
          imageStyle={{ borderRadius: 10 }}
        >
          <Image
            style={[imgStyle, theme.styles.mt1, theme.styles.mb1]}
            source={{ uri: img }}
            accessibilityLabel={alt}
          ></Image>
          <H3
            style={[fontSizeXL, titleStyle, theme.styles.mt2, theme.styles.mb2]}
          >
            {title}
          </H3>
          <LinkButton
            to={linkTo}
            style={{ ...theme.styles.mt2 }}
          >
            {formatMessage({ id: 'common.more-info' })}
          </LinkButton>
        </ImageBackground>
      </View>
      {/* reeeeeeessssssspppppp */}
      <View
        maxShowSize={LG_SIZE}
        style={[
          cardStyleLG,
          theme.styles.mt4,
          theme.styles.mb5,
          theme.styles.m1,
          theme.styles.flexColCenter,
        ]}
      >
        <ImageBackground
          style={[imgBackgroundXL]}
          source={{ uri: imgBackground }}
          imageStyle={{ borderRadius: 10 }}
        >
          <Image
            style={[imgStyleLG, theme.styles.mt1, theme.styles.mb1]}
            source={{ uri: img }}
            accessibilityLabel={alt}
          ></Image>
          <H3
            style={[fontSizeLG, titleStyle, theme.styles.mt2, theme.styles.mb2]}
          >
            {title}
          </H3>
          <Link
            style={{
              color: 'white',
              borderBottom: 'solid 2px #53d69a',
              fontFamily: 'Montserrat-Regular',
              paddingBottom: 5,
              fontSize: 12,
            }}
            to={linkTo}
          >
            {link}
          </Link>
        </ImageBackground>
      </View>
    </>
  )
}
export default injectIntl(DarkCard)
